import cart from '@ppcp/cart';
import {getSetting} from '@ppcp/utils';
import {MiniCartController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import ApplePayGateway from "../gateways/ApplePayGateway";

const settings = getSetting('ppcp_applepay_data');

const gateway = new ApplePayGateway({
    id: 'ppcp_applepay',
    cart,
    settings: settings,
    controller: null // Will be set after controller creation
});

// Create cart controller with gateway
const controller = new MiniCartController({
    id: 'ppcp_applepay',
    cart,
    context: new Context('minicart'),
    gateway,
    settings
});

controller.initialize();